import { IRecipient } from '@/types/Recipient';

export function arrangeRecipientSignOrder(
  newIndex: number,
  oldIndex: number,
  recipients: IRecipient[],
  drag: boolean
): IRecipient[] {
  const sortedRecipients: IRecipient[] = recipients.sort(
    (a: IRecipient, b: IRecipient) => a.orderNum - b.orderNum
  );
  const movedRecipient: IRecipient = sortedRecipients[oldIndex];
  if (drag) {
    const filteredRecipients: IRecipient[] = sortedRecipients.filter(
      (recipient: IRecipient) => recipient.id !== movedRecipient.id
    );
    filteredRecipients.splice(newIndex, 0, movedRecipient);

    return setRecipientSignOrder(filteredRecipients);
  } else {
    movedRecipient.orderNum = newIndex + 1;
    sortedRecipients.sort((a, b) => a.orderNum - b.orderNum);
    const updatedRecipients: IRecipient[] = fixRecipientsGaps(sortedRecipients);
    return updatedRecipients;
  }
}

export function setRecipientSignOrder(recipients: IRecipient[]): IRecipient[] {
  return recipients.map((recipient: IRecipient, index: number) => ({
    ...recipient,
    orderNum: index + 1,
  }));
}

export function fixRecipientsGaps(recipients: IRecipient[]): IRecipient[] {
  const updatedRecipients: IRecipient[] = [];
  recipients.forEach((recipient, i) => {
    const previousRecipient: IRecipient = recipients[i - 1];
    const previousOrganizedRecipient: IRecipient = updatedRecipients[i - 1];

    if (previousRecipient && recipient.orderNum === previousRecipient.orderNum) {
      updatedRecipients.push({ ...recipient, orderNum: previousOrganizedRecipient.orderNum });
    } else if (previousRecipient) {
      updatedRecipients.push({
        ...recipient,
        orderNum: previousOrganizedRecipient.orderNum + 1,
      });
    } else {
      updatedRecipients.push({ ...recipient, orderNum: i + 1 });
    }
  });
  return updatedRecipients;
}

export function getLabelName({ fullName, firstName, lastName, roleName }: IRecipient): string {
  if (fullName) {
    return fullName;
  }
  if (firstName || lastName) {
    return `${firstName} ${lastName}`;
  }
  return roleName;
}
